import { getJobCategories } from '../api';
import { sortArrayByFieldAsc } from '../helpers/general';
import { GET_JOB_CATEGORIES_SUCCESS } from './actionTypes';
import { dispatchErrorAction } from './index';

export function getAllJobCategories () {
  return dispatch => getJobCategories()
    .then(({ data }) => {
      const filteredData = data.filter(categoryData => categoryData.subcategory);
      const sortedCategoriesList = sortArrayByFieldAsc(filteredData, 'category_label');
      const sortedBySubcategoriesList = sortedCategoriesList.map(categoryData => {
        categoryData.subcategory = sortArrayByFieldAsc(categoryData.subcategory, 'skill_label');
        return categoryData;
      });
      dispatch({ type: GET_JOB_CATEGORIES_SUCCESS, jobCategories: sortedBySubcategoriesList });
      return sortedBySubcategoriesList;
    })
    .catch(error => { dispatchErrorAction(error, dispatch); });
}



// WEBPACK FOOTER //
// ./src/actions/jobCategories.js